<template>
  <div class="informationDisclosure">
    <z-fix-top
      v-if="isShowHead"
      ref="fixtop"
      keep-position
      class="fixtop"
      :style="{background: '#F7F7F7'}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navTitle"
      >
      </z-nav-bar>
    </z-fix-top>
    <z-loading v-if="loading" type="zz" size="60px" vertical class="message">正在加载</z-loading>
  </div>
</template>

<script>
import { NavBar, FixTop, Loading, Toast } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '@lib/utils'
import { queryDisclosureStatus } from '@api/resourceApi'
import native from '@zz-common/native-adapter';

const query = queryParams()

export default {
  name: 'informationDisclosureInit',
  data() {
    return {
      navTitle: '信息披露',
      uid: getCookie('uid'),
      orderId: query.orderId || this.$route.query.orderId || '',
      from: query.from || this.$route.query.from || '',
      loading: true,
      isShowHead: true
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    'z-loading': Loading
  },
  created() {
    if (native.in('miniprogram')) {
      this.isShowHead = false
    }
    native.setTitle({
      title: '信息披露'
    })
    if (!this.uid) {
      Toast('uid不存在')
      setTimeout(() => {
        native.close()
      }, 1000)
      return
    }
    if (!this.orderId) {
      Toast('订单id不存在')
      setTimeout(() => {
        native.close()
      }, 1000)
      return
    }
    const params = {
      uid: this.uid,
      orderId: this.orderId
    }
    queryDisclosureStatus(params).then(res => {
      const { status } = res;
      switch (status) {
        case '0':
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/confirm?orderId=${this.orderId}&from=${this.from}`,
            needClose: '1'
          })
          break;
        case '1':
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/result?orderId=${this.orderId}&from=${this.from}&status=${status}`,
            needClose: '1'
          })
          break;
        case '2':
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/result?orderId=${this.orderId}&from=${this.from}&status=${status}`,
            needClose: '1'
          })
          break;
        case '3':
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/result?orderId=${this.orderId}&from=${this.from}&status=${status}`,
            needClose: '1'
          })
          break;
        case '4':
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/result?orderId=${this.orderId}&from=${this.from}&status=${status}`,
            needClose: '1'
          })
          break;
        case '5':
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/result?orderId=${this.orderId}&from=${this.from}&status=${status}`,
            needClose: '1'
          })
          break;
        default:
          break;
      }
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
